import CreateUserScreen from './CreateUserScreen'

export default CreateUserScreen
